/* eslint-disable @typescript-eslint/no-explicit-any */
import { Badge } from "@/components/ui/badge";
import { OnPageErpEdit } from "../OnPageErpEdit";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const ReactTableCell = ({
  header,
  value,
  searchErpSku,
  onInlineUpdate,
  allData,
  activeInlineEdit,
  setActiveInlineEdit,
  retailerList,
}: any) => {
  switch (header) {
    case "status": {
      return (
        <Badge variant={value ? "default" : "destructive"}>
          {value ? "Active" : "Inactive"}
        </Badge>
      );
    }
    case "retailer_id": {
      const currentData = retailerList.find(
        (item: any) => item.retailer_id === value,
      );
      return (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger className="text-left">
              <span className="uppercase">
                {allData?.retailer_name || currentData?.retailer_name || value}
              </span>
            </TooltipTrigger>
            <TooltipContent>
              {allData?.retailer_name || currentData?.retailer_name || value}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    // case "erp_sku_code": {
    //   return (
    //     <TooltipProvider>
    //       <Tooltip>
    //         <TooltipTrigger className="text-left">
    //           <span className="uppercase">
    //             {allData?.erp_sku_name || value}
    //           </span>
    //         </TooltipTrigger>
    //         <TooltipContent>{allData?.erp_sku_name || value}</TooltipContent>
    //       </Tooltip>
    //     </TooltipProvider>
    //   );
    // }
    case "erp_sku_code": {
      return (
        <OnPageErpEdit
          header={header}
          value={value}
          searchErpSku={searchErpSku}
          onInlineUpdate={onInlineUpdate}
          allData={allData}
          activeInlineEdit={activeInlineEdit}
          setActiveInlineEdit={setActiveInlineEdit}
        />
      );
    }
    default: {
      return value;
    }
  }
};
